<template>
  <div class="parentx">
    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe.left="onSwipeLeft"
    >
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <!-- Header -->
        <div
          class="header-sidebar flex items-end justify-between"
          slot="header"
        >
          <!-- Logo -->
          <router-link
            tag="div"
            class="vx-logo cursor-pointer flex items-center"
            :to="dashboardRoute"
          >
            <img
              class="w-10 mr-4 fill-current text-primary"
              :src="require('../../../../public/Group-543.svg')"
            />
            <img
              v-show="isMouseEnter || !reduce"
              :src="require('../../../../public/Group-544.svg')"
              width="125px"
            />

          </router-link>

          <!-- Menu Buttons -->
          <div>
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon
                icon="XIcon"
                class="m-0 cursor-pointer"
                @click="
                  $store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
                "
              />
            </template>
          </div>
        </div>

        <div class="shadow-bottom" v-show="showShadowBottom" />
        <div
          v-if="$store.state.AppActiveUser.userType === 'doctorClinic'"
          class="w-full flex justify-center z-50"
        >
          <vs-select vs-multiple autocomplete v-model="selectedClinic">
            <vs-select-item
              :key="index"
              :value="item.clinicId.id"
              :text="item.clinicId.clinicName"
              v-for="(item, index) in $store.state.AppActiveUser
                .doctorAssociatedClinicIds"
              :clearable="false"
            />
          </vs-select>
        </div>
        <div class="pl-5 pr-3 nav-header">
          <SelectOrganization />
        </div>
        <!-- Menu Items -->
        <VuePerfectScrollbar
          ref="verticalNavMenuPs"
          class="scroll-area-v-nav-menu pt-2"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
          :key="$vs.rtl"
        >
          <template v-for="(item, index) in menuItemsUpdated">
            <!-- Group Item -->
            <vs-sidebar-group
              v-if="item.header && !verticalNavMenuItemsMin"
              class="truncate nav-group-header active"
              :key="`header-${index}`"
              :title="`${item.header}`"
              :open="isGroupActive(item)"
            >
              <template v-for="(child, index) in item.items">
                <v-nav-menu-item
                  v-if="!child.submenu"
                  :key="`child-${index}`"
                  :index="index"
                  :to="child.slug !== 'external' ? child.url : null"
                  :href="child.slug === 'external' ? child.url : null"
                  :icon="child.icon"
                  :target="child.target"
                  :featherIcon="child.featherIcon"
                  :isDisabled="child.isDisabled"
                  :slug="child.slug"
                >
                  <span v-show="!verticalNavMenuItemsMin" class="truncate">
                    {{ $t(child.i18n) || child.name }}
                  </span>
                  <vs-chip
                    class="ml-auto"
                    :color="child.tagColor"
                    v-if="child.tag && (isMouseEnter || !reduce)"
                  >
                    {{ child.tag }}
                  </vs-chip>
                </v-nav-menu-item>
              </template>
            </vs-sidebar-group>

            <vs-sidebar-group
              v-else-if="!item.url && !verticalNavMenuItemsMin"
              class="truncate nav-group-header active"
              :key="`vheader-${index}`"
              :title="`${item.name}`"
              :icon="item.icon"
              :isDisabled="item.isDisabled"
              :slug="item.slug"
              :open="isGroupActive(item)"
            >
              <template v-for="(child, index) in item.submenu">
                <v-nav-menu-item
                  v-if="!child.submenu && child.slug != 'patient-management'"
                  :key="`child-${index}`"
                  :index="index"
                  :to="child.slug !== 'external' ? child.url : null"
                  :href="child.slug === 'external' ? child.url : null"
                  :icon="child.icon"
                  :target="child.target"
                  :isDisabled="child.isDisabled"
                  :slug="child.slug"
                >
                  <span v-show="!verticalNavMenuItemsMin" class="truncate">
                    {{ $t(child.i18n) || child.name }}
                  </span>
                  <vs-chip
                    class="ml-auto"
                    :color="child.tagColor"
                    v-if="child.tag && (isMouseEnter || !reduce)"
                  >
                    {{ child.tag }}
                  </vs-chip>
                </v-nav-menu-item>
                <v-nav-menu-item
                  v-else-if="$store.state.AppActiveUser.isNationalMedicalDirector"
                  :key="`child-${index}`"
                  :index="index"
                  :to="child.slug !== 'external' ? child.url : null"
                  :href="child.slug === 'external' ? child.url : null"
                  :icon="child.icon"
                  :target="child.target"
                  :isDisabled="child.isDisabled"
                  :slug="child.slug"
                >
                  <span v-show="!verticalNavMenuItemsMin" class="truncate">
                    {{ $t(child.i18n) || child.name }}
                  </span>
                  <vs-chip
                    class="ml-auto"
                    :color="child.tagColor"
                    v-if="child.tag && (isMouseEnter || !reduce)"
                  >
                    {{ child.tag }}
                  </vs-chip>
                </v-nav-menu-item>
                <!-- Third Level Dropdown -->
            <vs-sidebar-group
                v-if="child.submenu && !verticalNavMenuItemsMin"
                class="truncate nav-group-header active"
                :key="`child-submenu-${index}-child-${index}`"
                :title="`${child.name}`"
                :open="isGroupActive(child)"
            >
                <template v-for="(subChild, subChildIndex) in child.submenu">
                    <v-nav-menu-item
                        v-if="!subChild.submenu"
                        :key="`subChild-${index}-child-${index}-${subChildIndex}`"
                        :index="subChildIndex"
                        :to="subChild.slug !== 'external' ? subChild.url : null"
                        :href="subChild.slug === 'external' ? subChild.url : null"
                        :icon="subChild.icon"
                        :target="subChild.target"
                        :isDisabled="subChild.isDisabled"
                        :slug="subChild.slug"
                    >
                        <span v-show="!verticalNavMenuItemsMin" class="truncate">
                            {{ $t(subChild.i18n) || subChild.name }}
                        </span>
                        <vs-chip
                            class="ml-auto"
                            :color="subChild.tagColor"
                            v-if="subChild.tag && (isMouseEnter || !reduce)"
                        >
                            {{ subChild.tag }}
                        </vs-chip>
                    </v-nav-menu-item>
                </template>
            </vs-sidebar-group>
            <!-- /Third Level Dropdown -->
              </template>
            </vs-sidebar-group>
            <!-- /Group Item -->

            <!-- /Normal Item -->
            <template v-else-if="!item.header">
              <!-- Nav-Item -->
              <v-nav-menu-item
                v-if="!item.submenu"
                :key="`item-${index}`"
                :index="index"
                :to="item.slug !== 'external' ? item.url : null"
                :href="item.slug === 'external' ? item.url : null"
                :icon="item.icon"
                :featherIcon="item.featherIcon"
                :target="item.target"
                :isDisabled="item.isDisabled"
                :slug="item.slug"
              >
                <span v-show="!verticalNavMenuItemsMin" class="truncate">{{
                  $t(item.i18n) || item.name
                }}</span>
                <vs-chip
                  class="ml-auto"
                  :color="item.tagColor"
                  v-if="item.tag && (isMouseEnter || !reduce)"
                  >{{ item.tag }}</vs-chip
                >
              </v-nav-menu-item>
            </template>
            <!-- /Normal Item -->
          </template>
        </VuePerfectScrollbar>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe.right="onSwipeAreaSwipeRight"
    />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VNavMenuItem from './VerticalNavMenuItem.vue';
import SelectOrganization from '../../../views/components/extra-components/select-organization/select-organization.vue';

export default {
  name: 'v-nav-menu',
  components: {
    VNavMenuItem,
    VuePerfectScrollbar,
    SelectOrganization,
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String },
    dashboardRoute: { type: String, default: '/super-admin/dashboard' },
  },
  data: () => ({
    selectedClinic: sessionStorage.getItem('doctorClinicSelectedClinic'),
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true,
    },
    showShadowBottom: false,
  }),
  computed: {
    isGroupActive() {
      return (item) => {
        let open = false;
        const path = this.$route.fullPath;
        let func = ({ items }) => {
          if (items) {
            items.forEach((item) => {
              item.url == path ? (open = true) : (open = false);
            });
          }
        };
        func(item);
        return open;
      };
    },
    menuItemsUpdated() {
      let clone = this.navMenuItems.slice();


      return clone;
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', val);
      },
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', val);
      },
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
    },
    selectedClinic(val) {
      sessionStorage.setItem('doctorClinicSelectedClinic', val);
      window.location.reload();
    },
    reduce(val) {
      const verticalNavMenuWidth = val
        ? 'reduced'
        : this.$store.state.windowWidth < 1200
        ? 'no-nav-menu'
        : 'default';
      this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
  },
  methods: {
    onSwipeLeft() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.isVerticalNavMenuActive = false;
    },
    onSwipeAreaSwipeRight() {
      if (!this.isVerticalNavMenuActive && this.showCloseButton)
        this.isVerticalNavMenuActive = true;
    },
    psSectionScroll() {
      this.showShadowBottom =
        this.$refs.verticalNavMenuPs.$el.scrollTop > 0 ? true : false;
    },
    mouseEnter() {
      if (this.reduce)
        this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce)
        this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', true);
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === 'vertical') {
          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin =
            this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit(
            'UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN',
            verticalNavMenuItemsMin
          );

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? 'reduced'
            : 'default';
          this.$store.dispatch(
            'updateVerticalNavMenuWidth',
            verticalNavMenuWidth
          );

          return;
        }
      }

      // Close NavMenu
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = true;

      // Update NavMenu Width
      this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');

      // Remove Only Icon in Menu
      this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false);
    },
    dashboardEnter() {
      let user = this.$store.state.AppActiveUser.userRole;
      if (user !== 'superAdmin') {
        return this.$router.push('/super-admin/dashboard');
      }
      if (user == 'franchise') {
        return this.$router.push('/franchise/dashboard');
      }
      if (user == 'clinic') {
        return this.$router.push('/clinic/dashboard');
      }
      if (user == 'admin') {
        return this.$router.push('/sub-admin/dashboard');
      }
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";
</style>
